import { validationTypes } from 'components/FormCreator/types';

export enum SettingsTabType {
	MyProfile = 'MyProfile',
	Contacts = 'Contacts',
	BankAccounts = 'BankAccounts',
	// ChangePlan = 'ChangePlan',
	FundsWithdrawal = 'FundsWithdrawal',
	// CreditCard = 'CreditCard',
}

export enum ViewerSettingsTabType {
	MyProfile = 'MyProfile',
}

export interface UserDetails {
	firstName?: string;
	lastName?: string;
	currentEmail?: string;
	newEmail: string;
	newEmailConfirm: string;
	currentPhone: string;
	newPhone: string;
	newPhoneConfirmation: string;
	selectedQuestion: string;
	securityAnswer: string;
}

export const userFieldsValidations: {
	[key in keyof Partial<UserDetails>]: validationTypes[];
} = {
	lastName: [validationTypes.requierd, validationTypes.englishAndHebrewLettersOnly],
	firstName: [validationTypes.requierd, validationTypes.englishAndHebrewLettersOnly],
	currentEmail: [validationTypes.email],
	newEmail: [validationTypes.email],
	newEmailConfirm: [validationTypes.match],
	currentPhone: [validationTypes.phone],
	newPhone: [validationTypes.phone],
	newPhoneConfirmation: [validationTypes.match],
	selectedQuestion: [validationTypes.requierd],
	securityAnswer: [validationTypes.requierd],
};

export enum FormInputsTypes {
	NAME = 'Name',
	EMAIL = 'Email',
	PHONE = 'Phone',
	LANGUAGE = 'Language',
	SECURITY_ANSWER = 'SecurityAnswer',
}

export enum TableSortTypes {
	ASC = 'asc',
	DESC = 'desc',
}

export enum AddBankFields {
	ACCOUNT_HOLDER_NAME = 'accountOwnerName',
	BANK_NAME = 'bankName',
	ACCOUNT_NUMBER = 'accountNumber',
	BRANCH_NUMBER = 'branchNumber',
	BANK_ACCOUNT_HOLDER_NAME = 'bankAccountHolderName',
	BANK_ID = 'bankId',
	FILE = 'file',
}

export interface BankDetails {
	accountOwnerName?: string;
	accountNumber?: string;
	branchNumber?: string;
	bankId: any;
	file: File;
}

export const newBankFieldsValidations: {
	[key in keyof Partial<BankDetails>]: validationTypes[];
} = {
	accountOwnerName: [validationTypes.requierd, validationTypes.englishAndHebrewLettersOnly],
	bankId: [validationTypes.requierd],
	accountNumber: [validationTypes.requierd],
	branchNumber: [validationTypes.requierd],
	file: [validationTypes.requierd],
};

export enum withdrawalOptions {
	REGULAR_WITHDRAWAL = 'regularWithdrawal',
	CLOSE_WITHDRAWAL = 'closeWithdrawal',
}

export type validationDataType = Record<validationTypes, string | number | boolean>